import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@interticket/core';

@Pipe({
  name: 'readTime',
  pure: false,
})
export class ReadTimePipe implements PipeTransform {

  constructor(
    private translateService: TranslateService
  ) { }

  transform(value: number): string {
    const label = value < 2 ? 'corporate_min_read' : 'corporate_mins_read';

    return +value ? `${value} ${this.translateService.get(label)}` : '';
  }

}
